/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vtp_Shipment_Not_FoundInputs */

const vi_vtp_shipment_not_found = /** @type {(inputs: Vtp_Shipment_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy vận đơn này.`)
};

/**

* @param {Vtp_Shipment_Not_FoundInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vtp_shipment_not_found = /** @type {((inputs?: Vtp_Shipment_Not_FoundInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vtp_Shipment_Not_FoundInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vtp_shipment_not_found(inputs)
});